import React from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Button,
} from 'react-bootstrap5';

export default function Card({
  title, description, onClick, className,
}) {
  return (
    <Row className="resource-card gx-0 h-100">
      <Col xl={4} className="pe-3 image-wrapper">
        <div className={`icon-wrapper ${className}`} />
      </Col>
      <Col xl={8} className="content-wrapper">
        <div className="ms-3 me-3">
          <h5 className="title">{title}</h5>
          <div
            className="small description"
          >
            {description}
          </div>
          <div className="d-flex justify-content-end mt-3">
            <Button onClick={onClick}>
              Open
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Card.defaultProps = {
  onClick: () => {},
  className: '',
};
